import React, { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Voices", href: "#voices" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-soft bg-cream/75 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1480px] items-center justify-between px-6 py-4 md:px-12">
        <a
          href="#top"
          data-testid="nav-logo"
          className="group flex items-center gap-2"
        >
          <span className="font-display text-xl font-extrabold tracking-tightest text-ink">
            REXOMI<span className="text-ultra">.</span>
          </span>
        </a>

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.18em] text-ink/70 transition-colors hover:text-ultra"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a

          href="#"
          data-youform-open="3wzd4p3n" data-youform-position="center"
          data-testid="nav-cta"
          className="group inline-flex items-center gap-2 rounded-sm border border-ink bg-ink px-4 py-2.5 font-mono text-xs uppercase tracking-[0.16em] text-cream transition-all hover:bg-acid hover:text-ink"
        >
          Let's talk
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:rotate-45" />
        </a>
      </div>
    </header>
  );
};

export default Navbar;